import React from "react";
import Mockman from "mockman-js";

function MockAPI() {
  return (
    
      <Mockman />
    
  );
}

export default MockAPI; 